'use strict';
var config = require('../config.js');
const jsSHA = require("jssha");

var informationRequestCtrl = function ($scope, Jobs, railApi, $translate, $stateParams, $rootScope, $state, $filter) {

    if ($stateParams.id) {
        $scope.infoRequest = railApi.get('approval_emails/' + $stateParams.id, { 'email_type': 'info_request' }).data;
        
    };

    $scope.exportLogUrl = config.apiIP + "/approval_emails/export_info_req_log_to_pdf?info_req_id=";
    $scope.exportInfoReqUrl = config.apiIP + "/approval_emails/export_information_request?info_req_id="

    $scope.answered = {}
    $scope.text_answers_attributes = []
    
    $scope.initFormData = function(){
        var hash = $stateParams.hash
        $scope.organization = $rootScope.clientSettings
        setTimeout(function() {
            railApi.post('approval_emails/check_hash', {hash: hash}, 'approval_emails').promise.then(function(data){
                if(data.email_type =='info_request'){
                    $scope.requestForm = data
                    $scope.section = data.forms[0]
                    var val = [{label: 'user.name.first', value: data.applicant_info.first_name},
                         {label: 'user.name.last', value: data.applicant_info.last_name},
                         {label: 'user.email', value: data.applicant_info.email},
                         {label: 'jobName', value: data.job_info.name.en},
                         {label: 'jobNameFr', value: data.job_info.name.fr},
                         {label: 'jobNameEs', value: data.job_info.name.es},
                         {label: 'organization.name', value: $scope.organization.name},
                         {label: 'contactEmail', value: $scope.organization.email},
                         {label: 'contactPhone', value: $scope.organization.phone},
                         {label: 'global.url.hostname', value: $scope.organization.url},
                         {label: 'clientName', value: $scope.organization.name},
                         {label: 'job.name', value: data.job_info.name.en},
                         {label: 'job.name_fr', value: data.job_info.name.fr},
                         {label: 'job.name_es', value: data.job_info.name.es},
                         {label: 'global.url.protocol', value: $scope.organization.url}]
                         
                    var emailString = data.message
                    val.forEach( function(value){
                        emailString = emailString.replaceAll('{{'+value.label+'}}', !_.isEmpty(value.value) ? value.value : '______')
                    })
        
                    $scope.offerPrev = emailString
                }else{
                    window.location.href="/expiredLink.html";
                }
                
            })
          }, 1000);
    }

    $scope.sendFormResponse = function(id, answers){
        railApi.post('approval_emails/'+id+'/answer_forms', {hash: $stateParams.hash, answers: answers, text_answers: $scope.text_answers_attributes}, 'approval_emails').promise.then(function(data){
            $scope.responseSubmittedModal = $scope.modal.open({
                templateUrl: 'responseSubmittedModal.ejs',
                scope: $scope,
                size: 'md'
            });
        })
    }

    $scope.employeeEncryption = function() {
        // console.log("hgUserData.id: " + $rootScope.hgUserData.id + " aasm: " + $rootScope.hgUserData);
        var today = new Date();
        var formattedDate = $filter('date')(today, 'yyyy-MM-dd');

        const shaObj = new jsSHA("SHA-256", "TEXT", { encoding: "UTF8" });
        shaObj.update($rootScope.hgUserData.email + $rootScope.hgUserData.role + "hiregroundSALT" + formattedDate);
        const hash = shaObj.getHash("HEX");

        $scope.employeeHash = hash;
    }

    $scope.generateLogs = function(applicant_profile){
        $scope.allLogs = [];
        $scope.allLogs = $scope.allLogs.concat(applicant_profile.applicant_profile_logs);
        $scope.allLogs = $scope.allLogs.concat(applicant_profile.applicant.applicant_logs);
        if($scope.allLogs[$scope.allLogs.length - 1] == undefined){
            $scope.allLogs.pop();
        }
    }

    $scope.addTextAnswer = function(id) {
        $scope.text_answers_attributes.push({'question_id': id, 'answer_text': ''})
    }

    $scope.getApplicantProfile = function(id){
        railApi.get('applicant_profiles/'+ id).promise.then(function(data){
            $scope.applicant_profile = data
            $scope.generateLogs(data)
        })
    }

    $scope.cancelInfoReq = function(id){
        railApi.put('approval_emails/'+id+'/cancel', {id: id}).promise.then(function(data){
            window.location.reload()
        })
    }
    $scope.resendInfoReq = function(id, due_date){
        railApi.put('approval_emails/'+id+'/resend_form', {id: id, due_date: due_date}, 'resend').promise.then(function(data){
            $scope.sendToReceiverConfirmationModal = $scope.modal.open({
                templateUrl: 'sendToReceiverConfirmationModal.ejs',
                scope: $scope,
                size: 'lg'
            });
        })
    }
    $scope.archive = function(id){
        railApi.put('approval_emails/'+id+'/archive', {id: id}).promise.then(function(data){
            window.location.reload()
        })
    }

    $scope.printIt = function(info_req_id){
        
        $scope.employeeEncryption();
        // railApi.post('approval_emails/export_log_to_pdf', {offer_letter_id: offer_letter_id});
        
        window.location.href=$scope.exportLogUrl + info_req_id + '&employeeid='+$rootScope.hgUserData.id + '&hash=' + $scope.employeeHash;
    };

    $scope.reloadThisPage = function(){
        window.location.reload();
    }

    $scope.exportInfoReq = function(info_req_id){
        $scope.employeeEncryption();
        window.location.href=$scope.exportInfoReqUrl + info_req_id + '&employeeid='+$rootScope.hgUserData.id + '&hash=' + $scope.employeeHash;
    }

    $scope.step1 = true;
    $scope.currStep = 1
    $scope.nextPrev = function(step){
        for(let stepz = 1; stepz < 4; stepz++){
            if(step == stepz){
                $scope['step' + stepz] = true
                $scope.currStep = stepz
            }else{
                $scope['step' + stepz] = false
            }
        }
    }
}

module.exports = informationRequestCtrl;